import React from 'react';
import styles from './Quiz.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import Question from '../Question/Question';
import { ClassicQuiz, QuestionImgQuiz, VarsImgQuiz } from './DifferentQuizzes';

const Quiz = ({
  variants,
  title,
  questionImgUrl,
  currentState,
  questionFontSize,
  marginTopQuiz,
  idVote,
}) => {
  const questionAnimation = 2;
  const isLong = title?.length > 160;

  const getCurrentTypeQuize = () => {
    if (questionImgUrl) {
      return 'questionImg';
    } else if (variants?.some((v) => v.varImgUrl)) {
      return 'varsImg';
    } else {
      return 'classic';
    }
  };

  const quizComponents = {
    classic: ClassicQuiz,
    questionImg: QuestionImgQuiz,
    varsImg: VarsImgQuiz,
  };

  const isStateCorrectVar = ['S2'].includes(currentState);
  const CurrentQuiz = quizComponents[getCurrentTypeQuize()];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={`${idVote}-quiz`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.container}
        style={{ marginTop: `${Number(marginTopQuiz)}rem` }}
      >
        <Question
          title={title}
          questionImgUrl={questionImgUrl}
          isLong={isLong}
          questionFontSize={questionFontSize}
        />

        {CurrentQuiz && (
          <CurrentQuiz
            variants={variants}
            isStateCorrectVar={isStateCorrectVar}
            questionImgUrl={questionImgUrl}
            questionAnimation={questionAnimation}
          />
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default React.memo(Quiz);
